import { Button } from 'components/Button'
import { ModalRef, PathwayActions } from 'constants/WorkingModePathwaysConstants'

interface PathwayAgendaDetailButtonsProps {
  actions: PathwayActions
  onOpen: (ref: ModalRef) => void
}

export const PathwayAgendaDetailButtons = ({ actions, onOpen }: PathwayAgendaDetailButtonsProps) => (
  <div className="flex gap-4 items-start">
    {actions.agenda && (
      <Button
        text="See agenda"
        color="white"
        className="px-[16px] py-[6px] border-2 min-w-24"
        onClick={() => onOpen(actions.agenda!)}
      />
    )}
    {actions.detail && (
      <Button
        text="See detail"
        color="black"
        className="px-[16px] py-[6px] min-w-24"
        onClick={() => onOpen(actions.detail!)}
      />
    )}
  </div>
)
